"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
/* eslint-disable no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
const shared_utils_1 = require("@air/shared-utils");
const auth_1 = __importStar(require("@aws-amplify/auth"));
const core_1 = require("@aws-amplify/core");
const uuid_1 = require("uuid");
const config_1 = require("./config");
const sanitizeEmail = (email) => email.trim().toLowerCase();
var UserStatus;
(function (UserStatus) {
    UserStatus["UserNotFoundException"] = "UserNotFoundException";
    UserStatus["NotAuthorizedException"] = "NotAuthorizedException";
    UserStatus["UserNotConfirmedException"] = "UserNotConfirmedException";
})(UserStatus || (UserStatus = {}));
function isUserRegistered(email) {
    return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield auth_1.default.signIn(sanitizeEmail(email), '123');
        }
        catch (e) {
            const code = e === null || e === void 0 ? void 0 : e.code;
            switch (code) {
                case 'UserNotFoundException':
                    resolve({
                        exists: false,
                        confirmed: false,
                    });
                    break;
                case 'NotAuthorizedException':
                    resolve({
                        exists: true,
                        confirmed: true,
                    });
                    break;
                case 'UserNotConfirmedException':
                    resolve({
                        exists: true,
                        confirmed: false,
                    });
                    break;
                default:
                    reject(e);
            }
        }
    }));
}
function resendSignUpVerificationCode(email) {
    return auth_1.default.resendSignUp(sanitizeEmail(email));
}
function verifySignUpVerificationCode(email, code) {
    return auth_1.default.confirmSignUp(sanitizeEmail(email), code);
}
function signIn(email, password) {
    return auth_1.default.signIn(sanitizeEmail(email), password);
}
function googleSignIn(customState) {
    return auth_1.default.federatedSignIn({
        provider: auth_1.CognitoHostedUIIdentityProvider.Google,
        customState: encodeURIComponent(JSON.stringify(Object.assign(Object.assign({}, customState), { provider: shared_utils_1.AuthProvidersByProviderName[shared_utils_1.GOOGLE_PROVIDER_NAME], providerName: shared_utils_1.AuthProvidersByProviderName[shared_utils_1.GOOGLE_PROVIDER_NAME] }))),
    });
}
function appleSignIn(customState) {
    return auth_1.default.federatedSignIn({
        provider: auth_1.CognitoHostedUIIdentityProvider.Apple,
        customState: encodeURIComponent(JSON.stringify(Object.assign(Object.assign({}, customState), { provider: shared_utils_1.AuthProvidersByProviderName[shared_utils_1.APPLE_PROVIDER_NAME], providerName: shared_utils_1.AuthProvidersByProviderName[shared_utils_1.APPLE_PROVIDER_NAME] }))),
    });
}
/**
 * @deprecated This has been replaced by ssoSamlSignin
 */
function oktaSignIn() {
    /**
     *  amplify does not have a predefined workflow for SAML providers so
     *  we need to do the following to prevent having to go through the
     *  cognito provided auth UI
     *  */
    const { oauth, userPoolWebClientId: clientId } = config_1.config.getAuthConfiguration();
    const { domain, redirectSignIn, responseType } = oauth;
    const url = `https://${domain}/oauth2/authorize?identity_provider=Okta&redirect_uri=${redirectSignIn}&response_type=${responseType}&client_id=${clientId}`;
    if (oauth.urlOpener && redirectSignIn) {
        oauth.urlOpener(url, redirectSignIn);
    }
    else {
        /* eslint-disable no-undef */
        window.location.assign(url);
    }
}
/**
 *
 * @param provider - the SAML provider id. This is the last 8 digits of the workspace id.
 */
function ssoSamlSignin(provider, customState) {
    auth_1.default.federatedSignIn({
        customProvider: provider,
        customState: encodeURIComponent(JSON.stringify(Object.assign(Object.assign({}, customState), { provider, providerName: shared_utils_1.AuthProvidersByProviderName[shared_utils_1.SAML_PROVIDER_NAME] }))),
    });
}
function signOut() {
    return auth_1.default.signOut();
}
function getCurrentSession() {
    return auth_1.default.currentAuthenticatedUser();
}
function isCurrentUserVerified() {
    return __awaiter(this, void 0, void 0, function* () {
        const currentAuthenticatedUser = yield auth_1.default.currentAuthenticatedUser();
        const userAttributes = yield auth_1.default.userAttributes(currentAuthenticatedUser);
        const verifiedByEmail = userAttributes.find(({ Name, Value }) => Name === 'email_verified' && (Value === null || Value === void 0 ? void 0 : Value.toLowerCase()) === 'true');
        return !!verifiedByEmail;
    });
}
function getCurrentUserInfo() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const response = yield auth_1.default.currentUserInfo();
        /**
         * Use this function tell if the current user's email has been verified.
         * Why not get it from response above or Auth.currentAuthenticatedUser() you ask?
         * @see https://github.com/aws-amplify/amplify-js/issues/7917
         */
        const currentUserIsVerified = yield isCurrentUserVerified();
        let identities = [];
        /**
         * Safely parsing the string due to Cognito's poor track record of response stability
         */
        try {
            if (typeof response.attributes.identities === 'string') {
                identities = JSON.parse(response.attributes.identities) || [];
            }
            else {
                identities = [];
            }
        }
        catch (error) {
            identities = [];
        }
        /**
         * At Air, we consider an email verified if the current user's email is actually verified
         * or if a third-party/federated IDP account is linked because we assume they have verified the email.
         * This is probably not ideal from a security standpoint.
         * Keeping this business logic in this package so the clients can use the centralized logic in one place
         */
        const email_verified = !!currentUserIsVerified || !!((_a = response.attributes.identities) === null || _a === void 0 ? void 0 : _a.length);
        return Object.assign(Object.assign({}, response), { attributes: Object.assign(Object.assign({}, response.attributes), { identities,
                email_verified }) });
    });
}
function changePassword(existingPassword, newPassword) {
    return __awaiter(this, void 0, void 0, function* () {
        const user = yield getCurrentSession();
        return auth_1.default.changePassword(user, existingPassword, newPassword);
    });
}
function getJWTToken() {
    return __awaiter(this, void 0, void 0, function* () {
        const authToken = config_1.config.getAuthorizationToken();
        if (authToken) {
            return authToken;
        }
        const { authTokenProvider } = config_1.config.getAuthConfiguration();
        if (authTokenProvider) {
            return authTokenProvider.getToken();
        }
        // fallback to amplify
        const session = yield auth_1.default.currentSession();
        return session.getIdToken().getJwtToken();
    });
}
// Email should be lowercased by here - internal helper function
function updateAttributes(attributes) {
    return __awaiter(this, void 0, void 0, function* () {
        const user = yield getCurrentSession();
        return auth_1.default.updateUserAttributes(user, attributes);
    });
}
function confirmAttribute(attribute, code) {
    return __awaiter(this, void 0, void 0, function* () {
        const user = yield getCurrentSession();
        return auth_1.default.verifyUserAttributeSubmit(user, attribute, code);
    });
}
function verifyAttribute(attribute) {
    return __awaiter(this, void 0, void 0, function* () {
        const user = yield getCurrentSession();
        return auth_1.default.verifyUserAttribute(user, attribute);
    });
}
function updateUserEmail(email) {
    return updateAttributes({
        email: sanitizeEmail(email),
    });
}
function confirmEmail(code) {
    return confirmAttribute('email', code);
}
function verifyEmail() {
    return verifyAttribute('email');
}
function forgotPassword(email) {
    return auth_1.default.forgotPassword(sanitizeEmail(email));
}
function confirmPassword(email, code, password) {
    return auth_1.default.forgotPasswordSubmit(sanitizeEmail(email), code, password);
}
function signUp(_a) {
    return __awaiter(this, arguments, void 0, function* ({ email, password, platform, }) {
        yield auth_1.default.signUp({
            username: sanitizeEmail(email),
            password,
            attributes: {
                'custom:platform': platform,
            },
        });
        const signinResult = yield signIn(email, password);
        auth_1.default.verifyUserAttribute(signinResult, 'email');
        return signinResult;
    });
}
/**
 * This function takes the state query param passed back from Cognito and decodes it
 * @param state - the state query param

 */
function decodeStateParam(state) {
    /**
     * I don't know why we need to split here but we do.
     * The useful information in the state query param comes after the -
     */
    const stateValue = state === null || state === void 0 ? void 0 : state.split('-')[1];
    /** We decode because we encode the values we pass in */
    return JSON.parse(decodeURIComponent((0, core_1.urlSafeDecode)(stateValue)));
}
const convertWorkspaceIdToSAMLProvider = (workspaceId) => {
    const splitWorkspace = workspaceId.split('-');
    return splitWorkspace.length === 5 ? splitWorkspace[4] : undefined;
};
const convertOrganizationIdToSAMLProvider = (organizationId) => organizationId.replaceAll('-', '');
const anonymousAccountSignUp = (_a) => __awaiter(void 0, [_a], void 0, function* ({ email, name, recaptchaToken, ignoreToken = false, }) {
    const username = `${email}_${(0, uuid_1.v4)()}`;
    const password = `AIRAPP_${(0, uuid_1.v4)()}`;
    yield auth_1.default.signUp({
        username,
        password,
        attributes: {
            name,
            email,
        },
        validationData: {
            recaptchaToken,
            ignoreToken: ignoreToken ? 'true' : 'false',
        },
    });
    const { attributes: { sub }, } = yield auth_1.default.signIn(username);
    return { sessionId: sub };
});
exports.Auth = {
    anonymousAccountSignUp,
    getCurrentUserInfo,
    changePassword,
    getJWTToken,
    signUp,
    isUserRegistered,
    resendSignUpVerificationCode,
    verifySignUpVerificationCode,
    signIn,
    googleSignIn,
    appleSignIn,
    oktaSignIn,
    ssoSamlSignin,
    signOut,
    getCurrentSession,
    updateUserEmail,
    confirmEmail,
    verifyEmail,
    forgotPassword,
    confirmPassword,
    decodeStateParam,
    convertWorkspaceIdToSAMLProvider,
    convertOrganizationIdToSAMLProvider,
};
//# sourceMappingURL=auth.js.map